var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSend = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1869 1.14646C15.2987 1.25825 15.3465 1.40981 15.3303 1.5556C15.3257 1.59639 15.3162 1.63673 15.3016 1.67562L10.6386 14.9985C10.5709 15.192 10.3919 15.3246 10.1871 15.3329C9.98221 15.3413 9.79303 15.2238 9.70976 15.0364L7.1212 9.21215L1.29693 6.62359C1.10959 6.54032 0.992061 6.35114 1.00042 6.1463C1.00878 5.94146 1.14133 5.76248 1.33483 5.69475L14.6577 1.03174C14.6969 1.01708 14.7375 1.0075 14.7786 1.003C14.8089 0.999667 14.8392 0.999128 14.8693 1.0013C14.985 1.00959 15.0984 1.05797 15.1869 1.14646ZM12.9305 2.69575L2.85554 6.22198L7.38927 8.23697L12.9305 2.69575ZM8.09638 8.94408L13.6376 3.40286L10.1114 13.4778L8.09638 8.94408Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/send.3ea5d8bf.svg";
export { ForwardRef as ReactComponent };